import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { createNamespace } from "../redux/createNamespace";
import type { User } from "./user.entity";

const userAdapter = createEntityAdapter<User>();
const initialState = userAdapter.getInitialState();

export const {
  reducer,
  actions: {
    upsertUser,
    upsertUserList,
    removeUser,
    removeUserList,
    clearUserList,
  },
} = createSlice({
  name: createNamespace("user"),
  initialState,
  reducers: {
    upsertUser: userAdapter.upsertOne,
    upsertUserList: userAdapter.upsertMany,
    removeUser: userAdapter.removeOne,
    removeUserList: userAdapter.removeMany,
    clearUserList: userAdapter.removeAll,
  },
});

const selectors = userAdapter.getSelectors();

/**
 * selectById 함수는 tsconfig.noUncheckedIndexedAccess 옵션을 활성화 하면 자연스럽게 undefined를 반환합니다.
 * 그러나 지금 이 옵션을 활성화 하고 있지않고, 활성화 하게 될 경우 많은 코드 변경이 발생하기 떄문에 래퍼 함수를 생성합니다.
 */
export const userSelectors = {
  selectIds: selectors.selectIds,
  selectById: (
    ...params: Parameters<typeof selectors.selectById>
  ): User | undefined => {
    return selectors.selectById(...params);
  },
  selectEntities: selectors.selectEntities,
  selectTotal: selectors.selectTotal,
  selectAll: selectors.selectAll,
};
